var routes = {
    home: '/',
    browse: '/browse',
    search: '/search',
    searchByType: '/search/:type',
    advancedSearch: '/advanced-search',
    titleRecommendations: '/media/:mediaId/recommendations',
    collectionById: '/collection/:collectionId',
    featuredCollection: '/collections/featured/:viewId',
    youMayLikeCollection: '/collections/youmaylike',
    mediaId: '/media/:id',
    mediaInfoId: '/media/info/:id',
    mediaRelatedId: '/media/related/:id',
    mediaRelatedForHoldSuccess: '/media/relatedforholdsuccess/:mediaId',
    mediaInfo: '/media/info',
    mediaAvailabilityId: '/media/availability/:id',
    mediaDownload: '/media/download/:format/:mediaId',
    mediaBorrow: '/media/borrow/:mediaId',
    mediaBorrowStatus: '/media/loans/:mediaId/:libraryKey',
    mediaReturn: '/media/return/:mediaId',
    patronRecommendations: '/patron/recommendations',
    patronRecommendationsDelete: '/patron/recommendations/:mediaId',
    patronMediaStarRatings: '/patron/media/star-rating/:titleId',
    mediaHoldStatus: '/media/holds/status/:mediaId',
    getSingleHold: '/media/hold/:mediaId',
    mediaPlaceHold: '/media/hold',
    mediaEditHold: '/media/holds/edit/:mediaId',
    mediaSuspendHold: '/media/holds/suspend/:mediaId',
    mediaRemoveHoldSuspension: '/media/holds/suspend/remove/:mediaId',
    mediaRemoveHold: '/media/holds/remove/:mediaId',
    accountSettings: '/account/settings',
    accountWishlist: '/account/lists/wishlist',
    accountWishlistStatus: '/account/lists/wishlist/status/:mediaId/:libraryKey',
    accountWishlistRemove: '/account/lists/wishlist/remove/:mediaId',
    accountWishlistAdd: '/account/lists/wishlist/add/:mediaId',
    supportMembers: '/support/members',
    supportCard: '/support/card',
    accountHolds: '/account/holds',
    accountInvalidCard: '/account/card/invalid',
    accountLoans: '/account/loans',
    accountRecommendations: '/account/lists/recommendations',
    accountLinkCard: '/account/linkcard',
    accountGetACard: '/account/sign-in?intent=gac',
    accountRatings: '/account/ratings',
    accountStartCardLink: '/account/initiate-card-link',
    accountSignIn: '/account/sign-in',
    accountSignInComplete: '/account/sign-in/complete',
    accountSignout: '/account/sign-out',
    appAuthenticate: '/account/app-authenticate',
    ozone: {
        signIn: '/account/ozone/sign-in',
        authenticate: '/account/signInOzone',
        accountSignoutComplete: '/account/sign-out/complete',
        external: '/account/ozone/external'
    },
    accountVerifyLinkedCards: '/account/verify-linked-card',
    accountLinkLibraryCardComplete: '/account/link-library-card/complete',
    patronEmail: '/patron/email',
    patronLendingPeriod: '/patron/media/lendingPeriods/:mediaId',
    rtlModalSuccess: '/rtl/modal-success/:id',
    goBack: '/goback',
    dlrRoom: '/dlr-room',
    dlrAuthenticate: '/BANGAuthenticate.dll',
    dlrMediaId: '/ContentDetails.htm',
    seriesbyTitle: '/series-by-title/:mediaId',
    updateHoldSettings: '/media/holds/settings',
    getBranches: '/branches',
    preferences: '/preferences',
    lendingSettings: '/lending-settings',
    reviews: '/media/reviews/:mediaId',
    relatedCarousel: '/media/relatedTitlesCarousel/:id',
    accountHistory: '/account/history',
    rest: {
        account: {
            get: '/rest/account/',
            limits: '/rest/account/limits',
            authLocal: '/rest/account/authenticate/local'
        },
        collections: {
            getById: '/rest/collections/:id'
        },
        media: {
            index: '/rest/media',
            related: '/rest/media/:id/relatedTitles',
            recommended: '/rest/media/:id/recommended',
            availableRelated: '/rest/media/:id/availableRelatedTitles'
        },
        subjects: {
            getGroupedByParent: '/rest/subjects/byparent',
            getCountByMediaType: '/rest/subjects/countby/mediatype'
        },
        search: {
            rtlPreview: '/rest/search/rtlPreview'
        },
        readingHistory: {
            index: '/rest/readingHistory',
            title: '/rest/readingHistory/title/:id',
            settings: '/rest/readingHistory/settings'
        },
        recommended: {
            index: '/rest/recommended',
            updateRtlAutoCheckout: '/rest/recommended/updateRtlAutoCheckout'
        },
        rooms: {
            get: '/rest/rooms/:roomId'
        },
        campaigns: {
            get: '/rest/campaigns/:campaignId'
        },
        preferences: {
            global : {
                index: '/rest/preferences/global/'
            }
        },
        idc: {
            phone: {
                sendCode: '/rest/idc/phone/send-code',
                verifyCode: '/rest/idc/phone/verify-code'
            },
            email: {
                sendCode: '/rest/idc/email/send-code',
                verifyCode: '/rest/idc/email/verify-code'
            },
            signUp: '/rest/idc/sign-up'
        }
    },
    // FYI: assets served at /assets should be considered immutable because
    // they are cached by browsers and intermediate load balancers. If you need
    // to change the asset, increment the version parameter to bust the cache
    assets: {
        css: {
            versionedColors: '/assets/v2/css/:version/colors.css',
            colors: '/assets/v1/css/colors.css'
        }
    },
    fulfillmentError: '/fulfillmentError',
    libbyIntercept: '/libbyPromo'
};

module.exports = {
    routes: Object.freeze(routes)
};
